"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TogglesService = void 0;
const tslib_1 = require("tslib");
class TogglesService {
    constructor(route) {
        this.SERVICE_URL = "/tdm-release-toggling/public/toggles";
        this.route = this.SERVICE_URL;
        this.httpOptions = {
            method: "GET",
            headers: {
                "accept": "application/json"
            },
            cache: 'no-cache',
            credentials: 'same-origin',
            referrerPolicy: 'no-referrer'
        };
        if (!!route) {
            this.route = route;
        }
    }
    get(toggleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const defaultResponse = {
                name: toggleName,
                active: false
            };
            if (!toggleName) {
                return defaultResponse;
            }
            try {
                const url = `${this.route}/${toggleName}`;
                // @ts-ignore
                const response = yield fetch(url, this.httpOptions);
                if (response.status !== 200) {
                    throw new Error(`Failed to fetch ${toggleName} toggle`);
                }
                return yield response.json();
            }
            catch (e) {
                return defaultResponse;
            }
        });
    }
    isActive(toggleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const toggle = yield this.get(toggleName);
            return toggle.active;
        });
    }
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // @ts-ignore
                const response = yield fetch(this.route, this.httpOptions);
                if (response.status !== 200) {
                    throw new Error('Failed to fetch all toggles');
                }
                return yield response.json();
            }
            catch (e) {
                return [];
            }
        });
    }
}
exports.TogglesService = TogglesService;
//# sourceMappingURL=toggles.service.js.map